import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

function Calendar({ tenantId }) {
  const [appointments, setAppointments] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [services, setServices] = useState([]);
  const [mechanics, setMechanics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [filterClientPlate, setFilterClientPlate] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [completeTarget, setCompleteTarget] = useState(null);
  const [serviceKm, setServiceKm] = useState('');
  const [newAppt, setNewAppt] = useState({
    customer_id: '',
    vehicle_id: '',
    service_id: '',
    mechanic_id: '',
    start_time: '',
    end_time: '',
    bay_number: 1
  });

  const fetchItems = () => {
    setLoading(true);
    apiFetch(`/appointments/list?tenant_id=${tenantId}`)
      .then(res => res.json())
      .then(data => {
        setAppointments(data.appointments || []);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
        alert("Erro ao carregar a agenda.");
      });
  };

  const fetchDependencies = () => {
    Promise.all([
      apiFetch(`/customers?tenant_id=${tenantId}`),
      apiFetch(`/services?tenant_id=${tenantId}`),
      apiFetch(`/vehicles?tenant_id=${tenantId}`),
      apiFetch(`/users?tenant_id=${tenantId}`)
    ]).then(async ([cRes, sRes, vRes, uRes]) => {
      const cData = await cRes.json();
      const sData = await sRes.json();
      const vData = await vRes.json();
      const uData = await uRes.json();
      setCustomers(cData.customers || []);
      setServices(sData.services || []);
      setVehicles(vData.vehicles || []);
      setMechanics(uData.users || []);
    }).catch(err => {
      console.error(err);
      alert("Erro ao carregar dependências.");
    });
  };

  useEffect(() => {
    fetchItems();
  }, [tenantId]);

  useEffect(() => {
    if (showModal) fetchDependencies();
  }, [showModal, tenantId]);

  const handleCreate = async (e) => {
    e.preventDefault();
    const res = await apiFetch(`/appointments?tenant_id=${tenantId}`, {
      method: 'POST',
      body: JSON.stringify({
        ...newAppt,
        customer_id: parseInt(newAppt.customer_id),
        vehicle_id: parseInt(newAppt.vehicle_id),
        service_id: parseInt(newAppt.service_id),
        mechanic_id: newAppt.mechanic_id ? parseInt(newAppt.mechanic_id) : null,
        bay_number: parseInt(newAppt.bay_number)
      })
    });
    if (res.ok) {
      setShowModal(false);
      fetchItems();
    } else {
      alert("Erro ao criar agendamento. Verifique se os horários estão preenchidos.");
    }
  };

  const getDayName = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '');
  };
  
  const getHour = (dateStr) => {
    return new Date(dateStr).getHours();
  };

  // 1 = Segunda, 6 = Sábado
  const daysOfWeek = ['seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
  const hoursOfDay = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17];

  const filteredAppointments = appointments.filter(apt => {
    const clientPlateStr = `${apt[1]} ${apt[2]}`.toLowerCase();
    const matchStr = clientPlateStr.includes(filterClientPlate.toLowerCase());
    const matchStatus = filterStatus === '' ? true : apt[7] === filterStatus;
    return matchStr && matchStatus;
  });

  const getApptsForSlot = (day, hour) => {
    return filteredAppointments.filter(apt => {
      const start = new Date(apt[4]);
      return getDayName(apt[4]) === day && start.getHours() === hour;
    });
  };

  if (loading) return <div className="stat-label">Carregando agenda...</div>;

  return (
    <div className="animate-fade">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.8rem', color: 'var(--text-primary)' }}>Calendário Semanal</h1>
          <p style={{ margin: 0, color: 'var(--text-secondary)' }}>Visão geral dos agendamentos</p>
        </div>
        <button className="btn-primary" onClick={() => setShowModal(true)}>+ Novo Agendamento</button>
      </div>

      {/* ── Advanced Filters ── */}
      <div className="toolbar" style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <div className="search-box" style={{ flex: 1, position: 'relative', minWidth: '250px' }}>
          <i className="fas fa-search" style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)' }}></i>
          <input type="text" placeholder="Buscar por cliente ou placa..." value={filterClientPlate} onChange={e => setFilterClientPlate(e.target.value)} style={{ width: '100%', padding: '0.625rem 1rem 0.625rem 2.5rem', border: '2px solid #e2e8f0', borderRadius: '10px', fontSize: '0.875rem' }} />
        </div>
        <select className="filter-select" value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={{ padding: '0.625rem 2.5rem 0.625rem 1rem', border: '2px solid #e2e8f0', borderRadius: '10px', fontSize: '0.875rem', background: 'white', cursor: 'pointer' }}>
          <option value="">Todos os Status</option>
          <option value="scheduled">Agendados</option>
          <option value="em_andamento">Em Andamento</option>
          <option value="completed">Prontos</option>
        </select>
      </div>

      <div style={{ overflowX: 'auto', background: 'var(--bg-main)', borderRadius: '12px', border: '1px solid var(--border)', padding: '1rem', marginBottom: '2rem' }}>
        <table style={{ width: '100%', minWidth: '800px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ width: '60px', padding: '1rem', borderBottom: '2px solid var(--border)', color: 'var(--text-secondary)' }}>Hora</th>
              {daysOfWeek.map(day => (
                <th key={day} style={{ padding: '1rem', borderBottom: '2px solid var(--border)', textTransform: 'capitalize', textAlign: 'center' }}>{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {hoursOfDay.map(hour => (
              <tr key={hour}>
                <td style={{ padding: '1rem', borderBottom: '1px solid var(--border)', borderRight: '1px solid var(--border)', color: 'var(--text-secondary)', fontWeight: 'bold', textAlign: 'center' }}>{hour}:00</td>
                {daysOfWeek.map(day => {
                  const slotAppts = getApptsForSlot(day, hour);
                  return (
                    <td key={`${day}-${hour}`} style={{ padding: '0.5rem', borderBottom: '1px solid var(--border)', borderRight: '1px solid var(--border)', verticalAlign: 'top', height: '80px', width: '15%' }}>
                      {slotAppts.map(apt => {
                        const isCompleted = apt[7] === 'completed';
                        const end = new Date(apt[5]);
                        const now = new Date();
                        const isOverdue = !isCompleted && end < now;
                        
                        let bgColor = '#dcfce7'; // green: scheduled / on time
                        let textColor = '#16a34a';
                        
                        if (isCompleted) {
                          bgColor = '#f1f5f9'; // gray: completed
                          textColor = '#475569';
                        } else if (isOverdue) {
                          bgColor = '#fee2e2'; // red: overdue / expired
                          textColor = '#ef4444';
                        } else if (apt[7] === 'em_andamento') {
                          bgColor = '#fef3c7'; // yellow: in progress
                          textColor = '#d97706';
                        }

                        return (
                          <div key={apt[0]} style={{
                            background: bgColor,
                            color: textColor,
                            padding: '0.5rem',
                            borderRadius: '6px',
                            marginBottom: '0.5rem',
                            fontSize: '0.75rem',
                            border: '1px solid rgba(0,0,0,0.05)',
                            opacity: isCompleted ? 0.6 : 1,
                            textDecoration: isCompleted ? 'line-through' : 'none',
                            position: 'relative',
                            fontWeight: isOverdue ? 'bold' : 'normal'
                          }}>
                            <strong>{apt[1]}</strong><br/>
                            {apt[2]} - {apt[3]}<br/>
                            Mecânico: {apt[8] || 'N/A'} (Box {apt[6]})
                          </div>
                        )
                      })}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="table-wrapper">
        <div style={{ padding: '1.5rem', borderBottom: '1px solid var(--border)' }}>
          <h3 style={{ fontSize: '1.2rem', margin: 0 }}>Lista Detalhada</h3>
        </div>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Veículo</th>
              <th>Mecânico</th>
              <th>Serviço</th>
              <th>Horário</th>
              <th>Box</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredAppointments.map((apt) => (
              <tr key={apt[0]}>
                <td>#{apt[0]}</td>
                <td style={{ fontWeight: '600' }}>{apt[1]}</td>
                <td><span className="logo-circle" style={{ width: 'auto', padding: '0 8px', borderRadius: '4px', fontSize: '0.8rem' }}>{apt[2]}</span></td>
                <td>{apt[8] || 'Não Alocado'}</td>
                <td>{apt[3]}</td>
                <td>{new Date(apt[4]).toLocaleString([], {day: '2-digit', month: '2-digit', hour: '2-digit', minute:'2-digit'})}</td>
                <td><div className="logo-circle" style={{ width: '25px', height: '25px', borderRadius: '50%', fontSize: '0.7rem' }}>{apt[6]}</div></td>
                <td>
                    <span style={{ 
                    padding: '4px 10px', 
                    borderRadius: '12px', 
                    fontSize: '0.75rem',
                    background: apt[7] === 'scheduled' ? '#dcfce7' : apt[7] === 'em_andamento' ? '#fef3c7' : '#e0f2fe',
                    color: apt[7] === 'scheduled' ? '#16a34a' : apt[7] === 'em_andamento' ? '#d97706' : '#0ea5e9',
                    fontWeight: 'bold'
                   }}>
                    {apt[7] === 'scheduled' ? 'Agendado' : apt[7] === 'completed' ? 'Pronto' : 'Em Andamento'}
                  </span>
                </td>
                <td>
                  {apt[7] === 'scheduled' && (
                    <button 
                      onClick={async () => {
                        if (window.confirm(`Deseja iniciar a OS #${apt[0]}?`)) {
                          // To implement: Start OS
                        }
                      }}
                      className="btn-primary" 
                      style={{ padding: '4px 8px', fontSize: '0.7rem', background: '#3b82f6', border: 'none', marginRight: '0.5rem' }}>
                      Iniciar
                    </button>
                  )}
                  {apt[7] !== 'completed' && (
                    <button 
                      onClick={() => { setCompleteTarget(apt); setServiceKm(''); }}
                      className="btn-primary" 
                      style={{ padding: '4px 8px', fontSize: '0.7rem', background: '#10b981', border: 'none' }}>
                      Concluir
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Modal: Concluir OS ── */}
      {completeTarget && (
        <div className="modal-overlay active" style={{ zIndex: 300 }}>
          <div className="modal-container" style={{ maxWidth: '420px', width: '90%' }}>
            <div className="modal-header">
              <h3>Finalizar OS #{completeTarget[0]}</h3>
              <p className="stat-label">{completeTarget[1]} — {completeTarget[2]}</p>
            </div>
            <div style={{ padding: '1.5rem' }}>
              <label style={{ display: 'block', fontWeight: '600', fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                <i className="fas fa-tachometer-alt" style={{ marginRight: '6px', color: 'var(--primary)' }}></i>
                Quilometragem do Veículo na Entrada (KM)
              </label>
              <input
                type="number"
                placeholder="Ex: 45000"
                value={serviceKm}
                onChange={e => setServiceKm(e.target.value)}
                style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px', boxSizing: 'border-box', fontSize: '1rem' }}
                autoFocus
              />
              <p style={{ fontSize: '0.8rem', color: 'var(--gray)', marginTop: '0.5rem', marginBottom: 0 }}>
                O KM registrado alimenta as previsões de manutenção via IA. Pode deixar em branco.
              </p>
              <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', marginTop: '1.5rem' }}>
                <button
                  type="button"
                  onClick={() => setCompleteTarget(null)}
                  style={{ padding: '0.625rem 1.25rem', borderRadius: '10px', border: '2px solid #e2e8f0', background: 'white', cursor: 'pointer', fontWeight: '600' }}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn-primary"
                  style={{ padding: '0.625rem 1.25rem', borderRadius: '10px', background: '#10b981' }}
                  onClick={async () => {
                    const kmParam = serviceKm ? `&service_km=${parseInt(serviceKm)}` : '';
                    const res = await apiFetch(`/appointments/${completeTarget[0]}/complete?tenant_id=${tenantId}${kmParam}`, {
                      method: 'POST'
                    });
                    if (res.ok) {
                      setCompleteTarget(null);
                      setServiceKm('');
                      fetchItems();
                    }
                  }}
                >
                  ✅ Confirmar Conclusão
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-container" style={{ maxWidth: '600px' }}>
            <div className="modal-header">
              <h3>Novo Agendamento</h3>
              <p className="stat-label">Preencha os dados para o serviço</p>
            </div>
            <form onSubmit={handleCreate}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div className="form-group">
                  <label>Cliente</label>
                  <select className="input-field" required value={newAppt.customer_id} onChange={e => setNewAppt({...newAppt, customer_id: e.target.value})}>
                    <option value="">Selecione...</option>
                    {customers.map(c => <option key={c[0]} value={c[0]}>{c[1]}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Veículo</label>
                  <select className="input-field" required value={newAppt.vehicle_id} onChange={e => setNewAppt({...newAppt, vehicle_id: e.target.value})}>
                    <option value="">Selecione...</option>
                    {vehicles.filter(v => v[4] === parseInt(newAppt.customer_id)).map(v => <option key={v[0]} value={v[0]}>{v[1]} - {v[2]}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div className="form-group">
                  <label>Serviço</label>
                  <select className="input-field" required value={newAppt.service_id} onChange={e => setNewAppt({...newAppt, service_id: e.target.value})}>
                    <option value="">Selecione...</option>
                    {services.map(s => <option key={s[0]} value={s[0]}>{s[1]}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Mecânico (Opcional)</label>
                  <select className="input-field" value={newAppt.mechanic_id} onChange={e => setNewAppt({...newAppt, mechanic_id: e.target.value})}>
                    <option value="">Qualquer mecânico</option>
                    {mechanics.filter(m => m[3] === 'mechanic' || m[3] === 'admin').map(m => <option key={m[0]} value={m[0]}>{m[1]}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div className="form-group">
                  <label>Início</label>
                  <input type="datetime-local" className="input-field" required value={newAppt.start_time} onChange={e => setNewAppt({...newAppt, start_time: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Fim (Previsão)</label>
                  <input type="datetime-local" className="input-field" required value={newAppt.end_time} onChange={e => setNewAppt({...newAppt, end_time: e.target.value})} />
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                <button type="submit" className="btn-primary">Criar Agendamento</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Calendar;
